import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { resolveProjectPaths } from '@next-adapter/config/paths/resolve-project-paths.js'

export function getEmailTemplatesDir(cwd: string, config: ResolvedBetterstartConfig): string {
  const paths = resolveProjectPaths(config)
  return path.join(cwd, ...paths.adminEmailTemplatesDir.split('/'))
}
